import { createSafeContext } from '../create-safe-context.mjs';

const [PopoverContextProvider, usePopoverContext] = createSafeContext("Popover component was not found in the tree");

export { PopoverContextProvider, usePopoverContext };
